import React from 'react'
import { Card, Button } from 'react-bootstrap'
import {sendMultipleMails} from '../../actions/mail';
import { useDispatch } from 'react-redux';
import './styles.css';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
}));


const EmailInfoBox = ({selectedBook, setSelectedBook}) => {
  const dispatch = useDispatch();  
  const classes = useStyles();
  
  const [open, setOpen] = React.useState(false);

  
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handleSubmit = () =>{
    dispatch(sendMultipleMails(selectedBook))
    setSelectedBook([]);
    setOpen(true);
  }
    
  const handleDeleteBooks = (book) =>{
      function arrayRemove(arr, value) { 
          return arr.filter(function(ele){ 
              return ele != value; 
          });
      }
      setSelectedBook(arrayRemove(selectedBook, book))
  }  

  return (
      <div>
        <Card
        bg={'light'}
        text={'dark'}
        style={{ width: '18rem' }}
        className="mb-2"
        >
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="success">
            Your book requests have been sent!
          </Alert>
        </Snackbar>
        <Card.Header>Emails</Card.Header>
        <Card.Body>
          {!selectedBook.length && <Card.Text> Add the emails to send multiple book requests at once. </Card.Text>}
          <Card.Text>
            <div>
              {selectedBook.map(book => ( 
                <div className="tag-item" key={book._id}>
                  {book.email}
                  <button
                    type="button"
                    className="button"
                    onClick={() => {handleDeleteBooks(book)}}
                  >
                    &times;
                  </button>
                </div>
              ))}
            </div>
          </Card.Text>
          {<Button variant="outline-primary" disabled = {selectedBook.length === 0} onClick = {handleSubmit}>Send Email</Button>}
        </Card.Body>
      </Card>  
    </div>
  )
}

export default EmailInfoBox
